@if ((detail$|async); as detail) {
  <div class="block print:hidden">
    <!-- Header -->
    <app-prd-header [title]="getRelevantProjectHandle(detail.commercialProjectName, detail.name) || '-'"
      [state]="statusTranslations[detail.status]"
      [mode$]="mode$"
      [projectReference]="detail"
      [kvwNumber]="detail.kvwNumber"
      (modeChanged)="onModeChange($event)"
      [showPublish]="detail.status === 'Concept'"
      [showConcept]="detail.status === 'Published'"
      (publishClicked)="publishReference()"
    (conceptClicked)="unpublishReference()"></app-prd-header>
    <app-prd-jumbotron [title]="detail.name || '-'"
      [commercialProjectName]="detail.commercialProjectName"
      [subtitle]="detail.city || '-'"
      [company]="detail.companyName || '-'"
    [photo]="detail.primaryPhoto"></app-prd-jumbotron>
    <!-- Content -->
    <div class="flex flex-wrap flex-col-reverse md:flex-row md:flex-nowrap container mx-auto max-w-screen-xl px-6 pb-10">
      <main class="flex-1 md:pr-6 lg:pr-20">
        <app-prd-description [text]="detail.description || ''" [mode$]="mode$" (save)="saveText($event)"></app-prd-description>
        <vwui-divider spacing="lg"></vwui-divider>
        <app-prd-photos [mode$]="mode$" (primaryUpdated)="refresh$.next(null)" [projectReference]="detail"></app-prd-photos>
        <vwui-tab-bar [selected]="tab" (vwuiTabChange)="onTabChange($event.detail)">
          <vwui-tab class="mt-4" tabId="contract">Contract</vwui-tab>
          <vwui-tab class="mt-4" tabId="attributes">Kenmerken</vwui-tab>
          <vwui-tab class="mt-4" tabId="team-members">Projectteam VolkerWessels</vwui-tab>
          <vwui-tab class="mt-4" tabId="relations">Ontwerpteam</vwui-tab>
          <vwui-tab class="mt-4" tabId="links">Documenten</vwui-tab>
        </vwui-tab-bar>
        <div>
          @switch (tab) {
            @case ('contract') {
              <app-prd-contract-attributes [mode$]="mode$" [refId]="detail.id"></app-prd-contract-attributes>
            }
            @case ('attributes') {
              <app-prd-attributes [mode$]="mode$" [refId]="detail.id"></app-prd-attributes>
            }
            @case ('team-members') {
              <app-prd-team-members
                [mode$]="mode$"
                [refId]="detail.id"
              ></app-prd-team-members>
            }
            @case ('relations') {
              <app-prd-relations
                [mode$]="mode$"
                [refId]="detail.id"
              ></app-prd-relations>
            }
            @case ('links') {
              <app-prd-links
                [mode$]="mode$"
                [refId]="detail.id"
              ></app-prd-links>
            }
          }
        </div>
      </main>
      <aside class="shrink-0 md:ml-auto w-full md:w-auto">
        <app-prd-properties [properties]="detail.properties|objectToMap" [propertyOrder]="propertyOrder"
        [propertyStyle]="{start: 'date', end: 'date'}"></app-prd-properties>
        <app-mini-map
          [center]="detail.longitude !== null && detail.latitude !== null ? [detail.longitude, detail.latitude] : null"
          [city]="detail.city || '-'"
          [address]="detail | locationStreetFormat"
        class="hidden md:block mt-6"></app-mini-map>
      </aside>
    </div>
  </div>
  <app-project-reference-print [projectReference]="detail"></app-project-reference-print>
}
